// This is supplied as a default value to responseTransformer which is passed in as requestOptions to apiRequest in apiSlice

interface HasId {
  id: string | number;
  [key: string]: unknown;
}

export function defaultMapper(data: Record<string, unknown>): Record<string, unknown> {
  const entries = Object.entries(data);
  const transformedData: Record<string, unknown> = {};
  entries.forEach(([key, val]) => {
    // Check each key's value to see if it's an array of objects AND that it contains a key called id
    if (Array.isArray(val) && val.length && (val[0] as HasId).id) {
      transformedData[key] = {} as Record<string | number, HasId>;
      transformedData[`${key}_ids`] = [] as (string | number)[];
      (val as HasId[]).forEach((item) => {
        // if it is an array of objects with a key of id inside, transform it to a map with the following structure:
        // data: { columnName: { [id]: record } }
        (transformedData[key] as Record<string | number, HasId>)[item.id] = item;
        // additionally also create an array of ids
        // data: { columnName_ids: [...ids] }
        (transformedData[`${key}_ids`] as (string | number)[]).push(item.id);
      });
    } else {
      transformedData[key] = val;
      if (Array.isArray(val)) transformedData[`${key}_ids`] = [];
    }
  });
  return transformedData;
}
